import { render, staticRenderFns } from "./editFollow.vue?vue&type=template&id=a86e1ab0&scoped=true&"
import script from "./editFollow.vue?vue&type=script&lang=js&"
export * from "./editFollow.vue?vue&type=script&lang=js&"
import style0 from "./editFollow.vue?vue&type=style&index=0&id=a86e1ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86e1ab0",
  null
  
)

export default component.exports